import { IAccruedSickHoursReducer } from 'models/AccruedSickHour'
import { Action } from 'redux'
import { isType } from 'ts-action'
import { GetAccruedSickHours, AccruedSickHoursFetching } from './actions'

const initialState: IAccruedSickHoursReducer = {
  meta: {
    code: 0,
    message: '',
  },
  isFetching: false,
  data: [],
}

export const accruedSickHoursReducer = (
  state = initialState,
  action: Action
): IAccruedSickHoursReducer => {
  if (isType(action, GetAccruedSickHours)) {
    const { payload } = action
    return {
      ...state,
      meta: payload.meta,
      data: payload.data,
    }
  }
  if (isType(action, AccruedSickHoursFetching)) {
    const { payload } = action
    return {
      ...state,
      isFetching: payload,
    }
  }
  return state
}
